
import { useState } from "react";
import { MessageTone, Message } from "@/types/message";
import { CardFooter } from "@/components/ui/card";
import RegenerateButton from "./RegenerateButton";
import ActionSection from "./footer/ActionSection";
import RegenerationDialog from "./RegenerationDialog";

interface MessageCardFooterProps {
  isAIMessage: boolean;
  isLatestAIMessage?: boolean;
  isInitialMessage?: boolean;
  messageId: string;
  onRegenerateAIResponse?: (messageId: string, tone: MessageTone, customInstructions?: string) => Promise<Message | null>;
  isRegenerating?: boolean;
  suggestedTone?: MessageTone;
  content?: string;
  orderNumber?: string;
  userEmail?: string;
  sellerEmail?: string;
  customInstructions?: string;
}

const MessageCardFooter = ({
  isAIMessage,
  isLatestAIMessage = false,
  isInitialMessage = false,
  messageId,
  onRegenerateAIResponse,
  isRegenerating = false,
  suggestedTone,
  content = "",
  orderNumber = "",
  userEmail = "",
  sellerEmail = "",
  customInstructions = ""
}: MessageCardFooterProps) => {
  // Dialog state
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  // Only show controls for AI messages
  if (!isAIMessage) {
    return null;
  }
  
  // Open the regeneration dialog
  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };
  
  // Handle regeneration from dialog
  const handleRegenerate = (tone: MessageTone, instructions?: string) => {
    if (onRegenerateAIResponse && isLatestAIMessage) {
      onRegenerateAIResponse(messageId, tone, instructions);
      setIsDialogOpen(false);
    }
  };
  
  return (
    <CardFooter className="pt-0 pb-3 px-4 flex flex-wrap gap-2 justify-between">
      <div className="flex flex-wrap gap-2 justify-between w-full">
        {onRegenerateAIResponse && isLatestAIMessage && (
          <RegenerateButton
            onClick={handleOpenDialog}
            isRegenerating={isRegenerating}
            isInitialMessage={isInitialMessage}
          />
        )}
        
        <ActionSection
          isLatestAIMessage={isLatestAIMessage}
          content={content}
          orderNumber={orderNumber}
          sellerEmail={sellerEmail}
        />
        
        {/* Regeneration Dialog */}
        <RegenerationDialog
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          onRegenerate={handleRegenerate}
          initialTone={suggestedTone || "polite"}
          initialInstructions={customInstructions}
          isRegenerating={isRegenerating}
          isInitialMessage={isInitialMessage}
        />
      </div>
    </CardFooter>
  );
};

export default MessageCardFooter;
